
(function (w, d) {
  'use strict';

  var DL = w.DJIDataLayer;
  if (!DL) return;

  /* ================================================================ */
  
  /* ================================================================ */

  var PAGES = {
    'dji-grand-opening-week': {
      campaign_id: 'grand_opening_week',
      campaign_name: 'DJI Grand Opening Week',

      
      hero: {
        root: '.dji-grand-opening-banner',
        component: 'hero_banner',
        component_id: 'campaign_hero',
        placement: 'campaign_hero',
        promotion_id: 'grand_opening_hero',
        cta: '.dji-grand-opening-banner__cta',
        cta_element_id: 'join_now'
      },

      
      wheel: {
        form: 'form.pb-form',
        email: 'input[type="email"].pb-input',
        consent: '#pb-gdpr',
        component: 'newsletter_form',
        component_id: 'campaign_spin_wheel',
        placement: 'campaign_spin_wheel',
        
        api: /popupboost|popup-boost|wheelify|spin[-_]?wheel/i,
        
        result: '.pb-result, .pb-coupon, .pb-prize, [class*="pb-"][class*="result"], [class*="pb-"][class*="coupon"]'
      },

      
      scroll: {
        component: 'page_engagement',
        component_id: 'campaign_page_scroll',
        placement: 'campaign_page',
        thresholds: [25, 50, 75, 100]
      }
    }
  };

  /* ================================================================ */
  
  /* ================================================================ */
  
  function defaultConfig(handle) {
    return {
      campaign_id: handle,
      campaign_name: handle,
      hero: {
        root: '.dji-grand-opening-banner',
        component: 'hero_banner',
        component_id: 'campaign_hero',
        placement: 'campaign_hero',
        promotion_id: handle + '_hero',
        cta: '.dji-grand-opening-banner__cta',
        cta_element_id: 'join_now'
      },
      wheel: {
        form: 'form.pb-form',
        email: 'input[type="email"].pb-input',
        consent: '#pb-gdpr',
        component: 'newsletter_form',
        component_id: 'campaign_spin_wheel',
        placement: 'campaign_spin_wheel',
        api: /popupboost|popup-boost|wheelify|spin[-_]?wheel/i,
        result: '.pb-result, .pb-coupon, .pb-prize, [class*="pb-"][class*="result"], [class*="pb-"][class*="coupon"]'
      },
      scroll: {
        component: 'page_engagement',
        component_id: 'campaign_page_scroll',
        placement: 'campaign_page',
        thresholds: [25, 50, 75, 100]
      }
    };
  }

  
  function resolveConfig(handle) {
    if (!handle) return null;
    var base = defaultConfig(handle);
    var over = PAGES[handle];
    if (!over) return base;
    var k;
    for (k in over) {
      if (k === 'hero' || k === 'wheel' || k === 'scroll') {
        var sub = over[k] || {};
        for (var sk in sub) base[k][sk] = sub[sk];
      } else {
        base[k] = over[k];
      }
    }
    return base;
  }

  var CFG = resolveConfig(DL.ctx.page_handle);
  if (!CFG) return;

  /* ================================================================ */
  
  /* ================================================================ */

  function txt(el) {
    return el && el.innerText ? el.innerText.trim().replace(/\s+/g, ' ').slice(0, 80) : '';
  }

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    var s = w.getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && r.width > 0 && r.height > 0;
  }

  function base(o, extra) {
    var out = {
      page_type: DL.ctx.page_type,
      component: o.component,
      component_id: o.component_id,
      placement: o.placement,
      campaign_id: CFG.campaign_id,
      campaign_name: CFG.campaign_name
    };
    for (var k in (extra || {})) out[k] = extra[k];
    return out;
  }

  /* ================================================================ */
  
  /* ================================================================ */

  function initHero() {
    var cfg = CFG.hero;
    var root = d.querySelector(cfg.root);
    if (!root) return;

    function promoName() {
      return txt(root.querySelector('h1, h2')) || cfg.promotion_id;
    }

    
    DL.observe(root, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
      if (!DL.once('view_promotion|' + cfg.promotion_id)) return;
      DL.push(
        'view_promotion',
        base(cfg, {
          element_id: 'promo_hero',
          promotion_id: cfg.promotion_id,
          promotion_name: promoName(),
          creative_slot: cfg.placement,
          exposure_rule: meta && meta.rule,
          exposure_ratio: meta && meta.ratio_observed
        })
      );
    });

    
    d.addEventListener(
      'click',
      function (evt) {
        var t = evt.target;
        if (!t || !t.closest) return;
        var cta = t.closest(cfg.cta);
        if (!cta) return;
        DL.afterTick(function () {
          
          if (!DL.isInteractive(cta)) return;
          DL.push(
            'select_promotion',
            base(cfg, {
              element_id: cfg.cta_element_id,
              promotion_id: cfg.promotion_id,
              promotion_name: promoName(),
              creative_slot: cfg.placement,
              
              cta_label: txt(cta),
              link_url: cta.getAttribute('href') || undefined,
              opens: 'anchor_scroll'
            })
          );
        });
      },
      true
    );
  }

  /* ================================================================ */
  
  /* ================================================================ */

  
  function initWheel() {
    var cfg = CFG.wheel;
    if (!cfg) return;

    
    if (!d.querySelector(cfg.form)) {
      DL.log('spin wheel form 尚未渲染，改用委托监听等待应用注入');
    }

    var pending = null;

    function wheelSource(extra) {
      return base(
        { component: cfg.component, component_id: cfg.component_id, placement: cfg.placement },
        extra
      );
    }

    function marketingConsent() {
      var box = d.querySelector(cfg.consent);
      return box ? !!box.checked : null;
    }

    function emitSuccess(how) {
      if (!pending) return;
      
      if (!DL.onceSession('generate_lead|' + cfg.component_id)) { pending = null; return; }
      DL.push(
        'generate_lead',
        wheelSource({
          element_id: 'spin_wheel_submit',
          lead_type: 'newsletter',
          subscription_source: 'campaign_spin_wheel',
          result: 'success',
          subscribe_method: 'spin_wheel',
          success_signal: how,
          consent_marketing_optin: pending.consent,
          
          has_email: pending.hasEmail
        })
      );
      pending = null;
    }

    
    d.addEventListener(
      'submit',
      function (evt) {
        if (!evt.target || !evt.target.matches || !evt.target.matches(cfg.form)) return;
        var emailEl = d.querySelector(cfg.email);
        pending = {
          at: Date.now(),
          consent: marketingConsent(),
          hasEmail: !!(emailEl && emailEl.value && emailEl.value.indexOf('@') > -1)
        };
        DL.push(
          'newsletter_submit_attempt',
          wheelSource({
            element_id: 'spin_wheel_submit',
            lead_type: 'newsletter',
            subscription_source: 'campaign_spin_wheel',
            subscribe_method: 'spin_wheel',
            consent_marketing_optin: pending.consent,
            has_email: pending.hasEmail
          })
        );
        
        w.setTimeout(function () {
          if (pending && Date.now() - pending.at >= 15000) {
            DL.log('spin wheel: 未在 15s 内观察到成功信号，不发送 generate_lead');
            pending = null;
          }
        }, 15000);
      },
      true
    );

    
    DL.onRequestSuccess(cfg.api, function () {
      if (pending) emitSuccess('api');
    });

    
    var mo = new MutationObserver(function () {
      if (!pending) return;
      var el = d.querySelector(cfg.result);
      if (el && visible(el)) emitSuccess('result_ui');
    });
    mo.observe(d.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  }

  /* ================================================================ */
  
  /* ================================================================ */

  
  function initScrollDepth() {
    var cfg = CFG.scroll;
    if (!cfg) return;
    var thresholds = (cfg.thresholds || [100]).slice().sort(function (a, b) { return a - b; });
    var startedAt = Date.now();
    var maxPct = 0;
    var ticking = false;

    function currentPct() {
      var doc = d.documentElement;
      var total = Math.max(doc.scrollHeight, d.body ? d.body.scrollHeight : 0);
      if (!total) return 0;
      var seen = (w.scrollY || w.pageYOffset || 0) + w.innerHeight;
      
      return Math.min(100, Math.round(((seen + 2) / total) * 100));
    }

    function check() {
      ticking = false;
      var pct = currentPct();
      if (pct <= maxPct) return;
      maxPct = pct;
      for (var i = 0; i < thresholds.length; i++) {
        var t = thresholds[i];
        if (pct < t) continue;
        if (!DL.onceSession('scroll_depth|' + DL.ctx.page_handle + '|' + t)) continue;
        DL.push(
          'page_scroll_depth',
          base(
            { component: cfg.component, component_id: cfg.component_id, placement: cfg.placement },
            {
              element_id: 'page_scroll',
              percent_scrolled: t,
              is_complete: t >= 100,
              page_handle: DL.ctx.page_handle,
              time_to_depth_ms: Date.now() - startedAt,
              page_height: Math.max(d.documentElement.scrollHeight, d.body ? d.body.scrollHeight : 0)
            }
          )
        );
      }
    }

    w.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        w.requestAnimationFrame(check);
      },
      { passive: true }
    );
    
    w.setTimeout(check, 1200);
  }

  /* ================================================================ */

  function start() {
    initHero();
    initWheel();
    initScrollDepth();
    DL.log('promotion tracking ready', CFG.campaign_id, '（仅 banner / 转盘订阅 / 浏览深度）');
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})(window, document);
